import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsOptionSelectedPipe } from './is-option-selected-pipe.pipe';

@NgModule({
  declarations: [IsOptionSelectedPipe],
  imports: [CommonModule],
  exports: [IsOptionSelectedPipe]
})
export class IsOptionSelectedPipeModule {}
